import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

@Component({
  selector: 'app-email-dialog',
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss']
})
export class EmailDialogComponent implements OnInit {
  submitted = false;
  reenteremail: any;
  myDate: any;
  currentUser: any;
  constructor(private toastr: ToastrService, private tokenStorageService: TokenStorageService,
    public dialogRef: MatDialogRef<EmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private authService: AuthService, private withouttokenService: AuthenticationService
  ) {
  }

  ngOnInit() {
    this.currentUser = this.tokenStorageService.getUser();
  }

  changeEmailIdBeforeVerified() {
    
    this.submitted = true;
    if (!this.reenteremail) {

      this.toastr.error("Enter email", 'Error');
    }
    else if (this.data != this.currentUser.userid) {

      this.toastr.error("Login again", 'Error');
    }
    else {

      var post = {
        userid: this.data,
        emailid: this.reenteremail
      };

      this.authService.changeEmailIdBeforeVerified(post).subscribe((response: { apiStatus: any; apiMessage: string | undefined; }) => {
        
        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');
          
          this.withouttokenService.updateMessagewithouttoken(this.currentUser);
          this.dialogRef.close(true);
        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }

      }, (err: any) => {
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {
          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  };


  closeModal() {
    this.dialogRef.close();
  }
}
